var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpsellFlowBlockActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 30,
    viewBox: "0 0 16 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8505 6.06433L8.97016 0.206481C8.69382 -0.068827 8.24602 -0.068827 7.96968 0.206481L2.08935 6.06433C1.81318 6.33947 1.81318 6.78573 2.08935 7.06086L2.5895 7.55913C2.86567 7.83427 3.31365 7.83427 3.58981 7.55913L7.41117 3.75236V27.8906H1.41309C1.22583 27.8906 1.0463 27.9647 0.913967 28.0965L0.208187 28.7997C-0.236528 29.2426 0.0784336 30 0.707145 30H8.11695C8.8967 30 9.52867 29.3704 9.52867 28.5938V3.75236L13.3499 7.55896C13.6262 7.83426 14.074 7.83426 14.3503 7.55896L14.8503 7.06086C15.1267 6.78573 15.1267 6.33947 14.8505 6.06433Z",
    fill: "#61a578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsellFlowBlockActions);
export default __webpack_public_path__ + "static/media/upsell-flow-block-actions.b6213fccb5ea6392d878ee89fdfc08fc.svg";
export { ForwardRef as ReactComponent };